export default __webpack_public_path__ + "static/media/gallery-wip-emitter_10.a5c0fbe7.jpg";